import { Controller } from "@hotwired/stimulus"

// Find a Practitioner practice addresses in membership registration (TMS-1761): "Add another
// address" adds a second from the template, which can be removed again. While there are two they
// read Practice Address 1 and 2, and no third can be added. A saved address that is removed is
// hidden and sent with `_destroy`, its fields disabled so they ask nothing; a new one just goes.
export default class extends Controller {
  static targets = ["list", "template", "address", "title", "add", "destroy"]
  static values = { max: { type: Number, default: 2 } }

  connect() {
    this.relabel()
  }

  add() {
    if (this.shown().length >= this.maxValue) return

    this.listTarget.appendChild(this.templateTarget.content.cloneNode(true))
    this.relabel()
    this.shown().at(-1)?.querySelector("input:not([type='hidden']), button")?.focus()
  }

  remove(event) {
    const address = event.currentTarget.closest("[data-directory-addresses-target='address']")
    if (!address) return

    const destroy = address.querySelector("[data-directory-addresses-target='destroy']")
    if (address.querySelector("input[name$='[id]']")) {
      destroy.value = "1"
      address.hidden = true
      address.querySelectorAll("input:not([type='hidden']), button").forEach((field) => { field.disabled = true })
    } else {
      address.remove()
    }
    this.relabel()
    if (this.hasAddTarget) this.addTarget.focus()
  }

  relabel() {
    const shown = this.shown()
    shown.forEach((address, index) => {
      const title = address.querySelector("[data-directory-addresses-target='title']")
      if (title) title.textContent = shown.length > 1 ? `Practice Address ${index + 1}` : "Practice Address"
    })
    if (this.hasAddTarget) this.addTarget.hidden = shown.length >= this.maxValue
    this.dispatch("change")
  }

  shown() {
    return this.addressTargets.filter((address) => !address.hidden)
  }
}
